import { cn } from '@/lib/cn';

/**
 * Icono — un icono de Bootstrap Icons guardado en la base, con respaldo.
 *
 * Vivía en `features/reconocimientos/piezas.tsx` y subió aquí el 2026-09-24,
 * cuando la Analítica pasó a React: la lista de «Valores más reconocidos»
 * enseña el mismo icono, y una feature no importa de otra.
 *
 * (El vanilla de la Analítica no lo pintaba: interpolaba `${v.icon}` como
 * texto, así que en pantalla salía «bi-star» escrito.)
 */
/** El icono, o el respaldo si lo guardado no tiene la forma que emite el
 *  selector de iconos del portal.
 *
 *  El vanilla llamaba a `Utils.iconHtml(icono, respaldo)`, que devuelve una
 *  cadena de HTML y hay que insertar con `innerHTML`. Aquí es un elemento: el
 *  nombre del icono viene de la base de datos —lo escribe quien crea un valor o
 *  una campaña— y entra en un `className`, no en marcado.
 *
 *  `aria-hidden` siempre: estos iconos acompañan a un texto que ya dice lo
 *  mismo. Un lector de pantalla que los anunciara leería «estrella Estrella». */
export function Icono({ nombre, respaldo, className }: {
  nombre?: string | null;
  respaldo: string;
  className?: string;
}) {
  const limpio = (nombre || '').trim();
  // Solo se acepta la forma que emite el selector de iconos del portal. Un
  // valor con espacios o con caracteres raros llegaría a `class` tal cual, y
  // aunque React no ejecuta nada desde ahí, sí puede añadir clases del portal
  // que no le tocan (`hidden`, por ejemplo, la haría desaparecer).
  const valido = /^(bi|mdi)-[a-z0-9-]+$/.test(limpio) ? limpio : respaldo;
  return <i className={cn('bi', valido, className)} aria-hidden="true" />;
}
